import React, { useEffect, useState } from "react";
import AboutHeader from "../../components/aboutHeader/aboutHeader";
import DashboardFooter from "../../components/DashBoardFooter/dashboardFooter";
import SideBarNav from "../../components/sideBarNav/sideBarNav";
import UserAccountWrapper from "../../components/userAcountWrapper/userAccountWrapper";
import { auth, firestore } from "../../db/config";
import firebase from "firebase";
import { useSelector } from "react-redux";
import Alert from "../../components/alert/alert";
export default function ChangePassword() {
  const userReducer = useSelector((state) => state.userReducer);
  const getUserDetails = userReducer.currentUser;

  const [passwordValue, setpasswordValue] = useState({
    current_password: "",
    new_password: "",
    confirmNewPassword: "",
  });
  const [alertMessage, setalertMessage] = useState({
    message: "",
    status: "",
    buttonStatus: false,
    loader: "",
  });
  const handleChangePassword = (value, attr) => {
    setpasswordValue({
      ...passwordValue,
      [attr]: value,
    });
  };

  const handleSubmit = () => {
    setalertMessage({
      ...alertMessage,
      loader: true,
    });
    if (passwordValue.current_password === getUserDetails.password) {
      if (passwordValue.new_password !== passwordValue.confirmNewPassword) {
        setalertMessage({
          message: "your new password does not match",
          status: "danger",
          buttonStatus: false,
          loader: false,
        });
      } else if (passwordValue.new_password.length < 6) {
        setalertMessage({
          message: "your password must be atleast 6 characters",
          status: "danger",
          buttonStatus: false,
          loader: false,
        });
      } else {
        auth.onAuthStateChanged((user) => {
          user
            .updatePassword(passwordValue.new_password)
            .then(() => {
              firestore
                .collection("users")
                .doc(user.uid)
                .update({ password: passwordValue.new_password })
                .then(() => {
                  setalertMessage({
                    message: "Password updated successful",
                    status: "success",
                    buttonStatus: false,
                    loader: false,
                  });
                })
                .catch((error) => {
                  setalertMessage({
                    message: error.message,
                    status: "danger",
                    buttonStatus: false,
                    loader: false,
                  });
                });
            })
            .catch((error) => {
              setalertMessage({
                message: error.message,
                status: "danger",
                buttonStatus: false,
                loader: false,
              });
            });
        });
      }
    } else {
      setalertMessage({
        message: "Incorrect password",
        status: "danger",
        buttonStatus: false,
        loader: false,
      });
    }
  };
  return (
    <div>
      <AboutHeader />
      <div class="page_title_section dashboard_title">
        <div class="page_header">
          <div class="container">
            <div class="row">
              <div class="col-xl-9 col-lg-7 col-md-7 col-12 col-sm-7">
                <h1>Change Password </h1>
              </div>
              <div class="col-xl-3 col-lg-5 col-md-5 col-12 col-sm-5">
                <div class="sub_title_section">
                  <ul class="sub_title">
                    <li>
                      {" "}
                      <a href="/"> Home </a>&nbsp; / &nbsp;{" "}
                    </li>
                    <li> Change Password</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SideBarNav />
      <div class="l-main">
        <UserAccountWrapper />
        <div class="password_notify_wrapper float_left">
          <div class="row">
            <div class="col-md-12 col-lg-12 col-sm-12 col-12">
              <div class="sv_heading_wraper heading_center">
                <h3>change password</h3>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12 col-xl-6 offset-xl-3 col-lg-8 offset-lg-2 col-sm-12 col-12">
              <div class="change_password_wrapper float_left">
                <div class="change_pass_field float_left">
                  <div class="change_field">
                    <label>Current password :</label>
                    <input
                      type="password"
                      name="password"
                      placeholder="**********"
                      value={passwordValue.current_password}
                      onChange={(evt) =>
                        handleChangePassword(
                          evt.target.value,
                          "current_password"
                        )
                      }
                    />
                  </div>
                  <div class="change_field">
                    <label>new password :</label>
                    <input
                      type="password"
                      name="password"
                      placeholder="**********"
                      value={passwordValue.new_password}
                      onChange={(evt) =>
                        handleChangePassword(evt.target.value, "new_password")
                      }
                    />
                  </div>
                  <div class="change_field">
                    <label>confirm new password :</label>
                    <input
                      type="password"
                      placeholder="**********"
                      value={passwordValue.confirmNewPassword}
                      onChange={(evt) =>
                        handleChangePassword(
                          evt.target.value,
                          "confirmNewPassword"
                        )
                      }
                    />
                  </div>
                  <div class="about_btn float_left">
                    {alertMessage.message ? (
                      <Alert details={{ ...alertMessage }} />
                    ) : (
                      ""
                    )}
                    <ul>
                      <li>
                        {alertMessage.loader ? (
                          <a className="handle__updates__button">
                            please wait...
                          </a>
                        ) : (
                          <a
                            className="handle__updates__button"
                            onClick={handleSubmit}
                          >
                            submit
                          </a>
                        )}
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <DashboardFooter />
      </div>
    </div>
  );
}
